import { computed } from 'mobx';
import { getIsViewModeSelected } from 'owa-command-ribbon-store';
import { type CommandingViewMode } from 'owa-outlook-service-option-store';
import {
    getDefaultMlrAppButtonStyles,
    getDefaultMlrAppRibbonButtonStylesForSelected,
} from '../multilineRibbonStyles';
import {
    getDefaultSlrAppRibbonButtonStyles,
    getDefaultSlrAppRibbonButtonStylesForSelected,
} from '../singleLineRibbonStyles';
import type { IButtonStyles } from '@fluentui/react';

const defaultRibbonStyles = computed((): IButtonStyles => {
    return getIsViewModeSelected(1)
        ? getDefaultSlrAppRibbonButtonStyles()
        : getDefaultMlrAppButtonStyles();
});

export const getDefaultRibbonStyles = (): IButtonStyles => defaultRibbonStyles.get();

const defaultRibbonStylesForSelected = computed((): IButtonStyles => {
    return getIsViewModeSelected(1)
        ? getDefaultSlrAppRibbonButtonStylesForSelected()
        : getDefaultMlrAppRibbonButtonStylesForSelected();
});

export const getDefaultRibbonStylesForSelected = (): IButtonStyles =>
    defaultRibbonStylesForSelected.get();
